"use client";

import { Toaster } from "react-hot-toast";

export default function ToastProvider() {
  return (
    <Toaster
      position="top-center"
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        duration: 2000,
        style: {
          background: "#fff",
          color: "#4A2C5E",
          padding: "16px",
          borderRadius: "16px",
          boxShadow: "0 8px 32px rgba(74, 44, 94, 0.15)",
          fontWeight: "600",
          fontSize: "14px",
        },
        success: {
          iconTheme: {
            primary: "#10B981",
            secondary: "#fff",
          },
        },
      }}
    />
  );
}